<script setup lang="ts">
/**
 * SummaryText —— 统一摘要文本渲染。
 *
 * 普通摘要不是富文本，默认走 Vue 插值即可；但为了修复中文破折号“——”
 * 在仿宋等字体里因 EM DASH 侧轴承产生的视觉空隙，需要把连续“——”包成
 * 带负 letter-spacing 的 span。这里先做 HTML 转义再注入，属于受控的
 * HTML 注入点（与 Icon.vue / RichText.ts 同列 audited seams）。
 */
import { computed } from 'vue';

import { connectEmDashesInText } from '@/composables/em-dash-connector';

const props = defineProps<{
  readonly text?: string | null;
}>();

const html = computed(() => (props.text ? connectEmDashesInText(props.text) : ''));
</script>

<template>
  <span v-html="html" />
</template>
